export const TESTIMONIALS_ANCHOR_ID = 'testimonials'

export const AUTH_BASE_PATH = '/auth'
// blog is outside of MainRoutes because it's not a part of the app, and is hosted on webflow
export const BLOG_PATH = '/blog'
export const BENCHMARK_POST_PATH = '/compensation-benchmarks'
export const BROWSE_POST_PATH = '/salaries'

export const MainRoutes = {
  About: '/about',
  Feedback: `/feedback`,
  Account: '/settings/account',
  Appearance: '/settings/appearance',
  Community: '/community',
  Home: '/',
  Invite: '/invite',
  Jobs: '/jobs',
  Login: `${AUTH_BASE_PATH}/signin`,
  Logout: `${AUTH_BASE_PATH}/signout`,
  Verified: `${AUTH_BASE_PATH}/verified`,
  OauthSsoCallback: `${AUTH_BASE_PATH}/signup/sso-callback`,
  SignInNotCompleted: `${AUTH_BASE_PATH}/signin-not-completed`,
  AuthComplete: '/auth-complete',
  Onboarding: '/onboarding',
  PrivacyPolicy: '/privacy',
  Profile: '/profile',
  ProfileContact: '/profile/contact',
  ProfileEditCredentials: '/profile/credentials',
  ProfileSalaries: '/profile/salaries',
  ProfileSalariesAdd: '/profile/salaries/add',
  ProfileSalariesEdit: '/profile/salaries/edit',
  ProfileOptional: '/profile/optional',
  Resignin: `${AUTH_BASE_PATH}/resignin`,
  Salary: '/o',
  DefaultSalary: `/o/-/physician/salary`,
  Settings: '/settings',
  SignUp: `${AUTH_BASE_PATH}/new-user`,
  Terms: '/terms-of-use',
  CookiePolicy: '/cookies',
  Updates: '/updates',
  VerifyRequest: `${AUTH_BASE_PATH}/verify-request`,
  Waitlist: '/waitlist',
  NotFound: '/404',
  AuthError: `${AUTH_BASE_PATH}/error`,
  List: '/list',
  Browse: '/browse',
}
